import axios from "axios";
import API_CONFIG from "../../config/api";

const base = API_CONFIG.API_URL;

const unwrap = (response) => response?.data || {};

export async function fetchTreasuryFlows(params) {
  const data = unwrap(await axios.get(`${base}/treasury/flows`, { params }));
  return {
    rows: data.success ? data.data || [] : [],
    total: Number(data.pagination?.total || 0),
  };
}

export async function fetchTreasuryTotals(params) {
  const data = unwrap(await axios.get(`${base}/treasury/flows/totals`, { params }));
  const totals = data.success ? data.data || {} : {};
  return {
    incoming: Number(totals.total_incoming || 0),
    outgoing: Number(totals.total_outgoing || 0),
    count: Number(totals.total_count || 0),
    currency: totals.currency_symbol || "F",
    currencyCount: Number(totals.currency_count || 0),
    balance:
      totals.total_treasury_balance == null
        ? null
        : Number(totals.total_treasury_balance),
    balanceAsOf: totals.treasury_balance_as_of || null,
    accountCount: Number(totals.treasury_account_count || 0),
    balanceCurrency: totals.treasury_currency_symbol || "F",
    balanceCurrencyCount: Number(totals.treasury_currency_count || 0),
  };
}

export async function fetchTreasuryAccounts(params) {
  const data = unwrap(await axios.get(`${base}/treasury/accounts`, { params }));
  return data.success ? data.data || [] : [];
}

export async function saveTreasuryAccount(id, payload) {
  if (id) return axios.put(`${base}/treasury/accounts/${id}`, payload);
  return axios.post(`${base}/treasury/accounts`, payload);
}

export async function deactivateTreasuryAccount(id) {
  return axios.delete(`${base}/treasury/accounts/${id}`);
}

export async function fetchTreasuryMovements(params) {
  const data = unwrap(await axios.get(`${base}/treasury/movements`, { params }));
  return {
    rows: data.success ? data.data || [] : [],
    total: Number(data.pagination?.total || 0),
  };
}

export async function createTreasuryMovement(payload) {
  return axios.post(`${base}/treasury/movements`, payload);
}

export async function createTreasuryTransfer(payload) {
  return axios.post(`${base}/treasury/transfers`, payload);
}
